<template>
  <p @click="consultationClick" class="ywbd"><a href="#">有问<br />必答</a></p>
</template>
<script>
    import {consultationFactory} from '../src/consultation';

    export default{
        props: ['schoolid'],
        data: function () {
            return {
              consultationData:consultationFactory.findById(this.schoolid)
            }
        },
        methods: {
          consultationClick(){
            consultationFactory.openHref(this.consultationData);
          }
        },
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// components/ConsultationInfo.vue